const setCompanyInfo = (data) => {
  console.log("set company info data",data);  
  return {
    type: "SET_COMPANYINFO",
    payload: { data },
  };
};
export { setCompanyInfo };
